import React, { FC, useState, useEffect } from "react";
import classNames, { Argument } from "classnames/dedupe";

import { PocketIcon, ReturnsIcon, ShippingIcon } from "../../../icons";
import { Column, Row } from "../../Fundamentals/Grid";

export interface IUSPBannerProps {
  shippingLabel?: string;
  returnLabel?: string;
  pocketLabel?: string;
  classes?: {
    root: Argument;
  };
  hasFullWidth?: boolean;
}

const USPBanner: FC<IUSPBannerProps> = ({
  classes,
  shippingLabel,
  returnLabel,
  pocketLabel,
  hasFullWidth,
}) => {
  const [animateClass, setAnimateClass] = useState("animate");

  useEffect(() => {
    const timer = setTimeout(() => {
      setAnimateClass("");
      setTimeout(() => {
        setAnimateClass("animate");
      }, 10);
    }, 10000);

    return () => {
      clearTimeout(timer);
    };
  }, [animateClass]);

  return (
    <div
      className={classNames("header-top container-fluid", classes?.root, {
        "max-width-100": hasFullWidth,
      })}
      data-testid="USPBanner__Testid"
    >
      <Row classes={{ root: "header-top__wrapper" }}>
        {shippingLabel && (
          <Column
            classes={{
              root: `header-top__content slide--1 ${animateClass}`,
            }}
          >
            <ShippingIcon />
            {shippingLabel}
          </Column>
        )}

        {returnLabel && (
          <Column
            classes={{ root: `header-top__content slide--2 ${animateClass}` }}
          >
            <ReturnsIcon />
            {returnLabel}
          </Column>
        )}

        {pocketLabel && (
          <Column
            classes={{
              root: `header-top__content slide--3 ${animateClass}`,
            }}
          >
            <PocketIcon />
            {pocketLabel}
          </Column>
        )}
      </Row>
    </div>
  );
};

export default USPBanner;
